// extracted by mini-css-extract-plugin
export var dropdown = "_s1-0";
export var imageWrapper = "_s1-3";
export var itemNameContainer = "_s1-1";
export var productImage = "_s1-2";
export var spinnerWrapper = "_s1-4";